import Container from '@/components/Container';
import SkusMobileBreadCrumbs from './SkusMobileBreadCrumbs';
import SkusMobileAlgoliaFilters from './SkusMobileAlgoliaCustom/SkusMobileAlgoliaFilters';
import { Fragment, useEffect, useState } from 'react';
import SkusMobileAlgoliaHits from './SkusMobileAlgoliaCustom/SkusMobileAlgoliaHits';
import SkusMobileAlgoliaPagination from './SkusMobileAlgoliaCustom/SkusMobileAlgoliaPagination';
import { SkusMobileProps } from '@/types/props/components/skus';
import SkusMobileAlgoliaShowFilters from './SkusMobileAlgoliaCustom/SkusMobileAlgoliaShowFilters/SkusMobileAlgoliaShowFilters';
import { Transition } from '@headlessui/react';
import { deleteCookie, setCookie } from 'cookies-next';
import cookiesConstants from '../../../constants/cookies.constants';
export default function SkusMobile({ allSortsCustomTranslated, hasFilterCookie }: SkusMobileProps) {
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [filtersAreOpen, setFiltersAreOpen] = useState<boolean>(hasFilterCookie);

  useEffect(() => {
    if (filtersAreOpen) {
      setCookie(cookiesConstants.COOKIES.FILTERS_ARE_OPEN.name, 'true');
    } else {
      deleteCookie(cookiesConstants.COOKIES.FILTERS_ARE_OPEN.name);
    }

    return () => {
      deleteCookie(cookiesConstants.COOKIES.FILTERS_ARE_OPEN.name);
    };
  }, [filtersAreOpen]);

  return (
    <>
      <Transition
        as={Fragment}
        show={filtersAreOpen}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        unmount={false}
      >
        <Container>
          <div className="tw-py-8">
            <SkusMobileAlgoliaShowFilters
              setFiltersAreOpen={setFiltersAreOpen}
              filtersAreOpen={filtersAreOpen}
            />
          </div>
        </Container>
      </Transition>
      <Transition
        as={Fragment}
        show={filtersAreOpen === false}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        unmount={false}
      >
        <Container>
          <div>
            <SkusMobileBreadCrumbs />
          </div>
          <div className="tw-py-8">
            <SkusMobileAlgoliaFilters
              viewMode={viewMode}
              setViewMode={setViewMode}
              allSortsCustomTranslated={allSortsCustomTranslated}
              setFiltersAreOpen={setFiltersAreOpen}
            />
          </div>

          <SkusMobileAlgoliaHits viewMode={viewMode} isLowestAskSortBySelected={false} />

          <SkusMobileAlgoliaPagination />
        </Container>
      </Transition>
    </>
  );
}
